import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from "recompose";

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import red from '@material-ui/core/colors/red';
import green from '@material-ui/core/colors/green';
import yellow from '@material-ui/core/colors/yellow';
import grey from '@material-ui/core/colors/grey';

import IntegrationReactSelect from '../Common/IntegrationReactSelect';
import Progress from '../Common/Progress';
import TagsComponent from '../Common/TagsComponent';
import { projectActions } from '../../_actions';

const styles = theme => ({
    Content: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    button: {
        margin: theme.spacing.unit,
    },
    paper: {
        position: 'absolute',
        width: '80%',
        [theme.breakpoints.down('sm')]: {
            height: '90%',
            overflow: 'scroll',
        },
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
    },
    textField: {
        width: '90%',
        margin: theme.spacing.unit,
    },
    margin: {
        margin: theme.spacing.unit,
    },
    //RadioGroup
    formControl: {
        margin: theme.spacing.unit,
    },
    group: {
        flexDirection: 'row',
    },
    greenRoot: {
        color: green[600],
        '&$checked': {
            color: green[500],
        },
    },
    redRoot: {
        color: red[600],
        '&$checked': {
            color: red[500],
        },
    },
    yellowRoot: {
        color: yellow[600],
        '&$checked': {
            color: yellow[500],
        },
    },
    greyRoot: {
        color: grey[600],
        '&$checked': {
            color: grey[500],
        },
    },
    checked: {
    }
});

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

class FormComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Tag: [],
            ProjectId: '',
            ClientId: '',
            ProjectName: '',
            SalesId: '',
            DepartmentId: '',

            DealId: '',
            DealTitle: '',
            DealOrgName: '',
            DealOwnerName: '',
            Status: '1',

            Valid: true, //All
            ClientIdValid: true,
            ProjectNameValid: true,
            SalesIdValid: true,
            DepartmentIdValid: true,
            StatusValid: true,

            importPipedriveOpen: false,
            mode: 'ADD',
            modalTitle: 'Add Project',
            openProgress: false
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.projectData && nextProps.projectData !== this.props.projectData) {
            this.setState({
                ProjectId: nextProps.projectData.id === null ? '' : nextProps.projectData.id,
                ClientId: nextProps.projectData.ClientId === null ? '' : nextProps.projectData.ClientId,
                ProjectName: nextProps.projectData.ProjectName === null ? '' : nextProps.projectData.ProjectName,
                SalesId: nextProps.projectData.SalesId === null ? '' : nextProps.projectData.SalesId,
                DepartmentId: nextProps.projectData.DepartmentId === null ? '' : nextProps.projectData.DepartmentId,

                DealId: nextProps.projectData.DealId,
                DealTitle: nextProps.projectData.DealTitle,
                DealOrgName: nextProps.projectData.DealOrgName,
                DealOwnerName: nextProps.projectData.DealOwnerName,
                Tag: nextProps.projectData.Tag,
                Status: nextProps.projectData.ProgressStatus,

                mode: 'EDIT',
                modalTitle: 'Edit Project'
            });
        }
    }

    handleClose = () => {
        this.cleanData();
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    handleSave = () => {

        this.setState({
            Valid: true,
            ClientIdValid: true,
            ProjectNameValid: true,
            SalesIdValid: true,
            DepartmentIdValid: true,
        })

        if (this.state.ClientId === '') {
            this.setState({
                ClientIdValid: false,
                Valid: false
            })
        }
        if (this.state.ProjectName === '') {
            this.setState({
                ProjectNameValid: false,
                Valid: false
            })
        }
        if (this.state.SalesId === '') {
            this.setState({
                SalesIdValid: false,
                Valid: false
            })
        }
        if (this.state.DepartmentId === '') {
            this.setState({
                DepartmentIdValid: false,
                Valid: false
            })
        }

        const DataProcessing = async () => {
            try {
                this.setState({
                    openProgress: true
                })

                var inputData = {
                    'ProjectId': this.state.ProjectId,
                    'ClientId': this.state.ClientId,
                    'ProjectName': this.state.ProjectName,
                    'ProjectStatus': 'A',
                    'SalesId': this.state.SalesId,
                    'DepartmentId': this.state.DepartmentId,
                    'Tag': JSON.stringify(this.state.Tag),
                    'CreatedUserId': this.props.user.id,
                    'UpdatedUserId': this.props.user.id,
                    'ProgressStatus': this.state.Status,
                };

                if (this.state.mode === 'ADD') {
                    await this.props.dispatch(projectActions.insert(inputData));
                }
                else if (this.state.mode === 'EDIT') {
                    await this.props.dispatch(projectActions.update(inputData));
                }

                await this.props.dispatch(projectActions.getAll());
                await this.cleanData();

            } catch (e) {
                console.error("Problem", e)
            }
        }

        if (this.state.Valid) {
            DataProcessing();
        }
    }

    handleMultiTag = (TagData) => {
        this.setState({
            Tag: TagData
        })
    }

    handleSelectData = (data) => {
        if (data.type === 'ClientId') {
            this.setState({
                ClientId: data.id
            })
        }
        else if (data.type === 'UserId') {
            this.setState({
                SalesId: data.id
            })
        }
        else if (data.type === 'DepartmentId') {
            this.setState({
                DepartmentId: data.id
            })
        }
    }

    cleanData() {
        this.setState({
            ProjectId: '',
            ClientId: '',
            ProjectName: '',
            SalesId: '',
            DepartmentId: '',

            Tag: [],
            DealId: '',
            DealTitle: '',
            DealOrgName: '',
            DealOwnerName: '',

            ClientIdValid: true,
            ProjectNameValid: true,
            SalesIdValid: true,
            DepartmentIdValid: true,

            mode: 'ADD',
            modalTitle: 'Add Project',
            openProgress: false
        });

        this.props.close();
    }

    render() {
        const { classes, users, clients, departments } = this.props;

        return (
            <div>
                <Progress openProgress={this.state.openProgress} />
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.props.open}
                    onClose={this.handleClose}
                >
                    <div style={getModalStyle()} className={classes.paper}>
                        <Typography id="modal-title" style={{ fontSize: 40 }}>
                            {this.state.modalTitle}
                        </Typography>

                        <TagsComponent handleMultiTag={this.handleMultiTag} tags={this.state.Tag} />

                        <div style={{ marginTop: '20px' }} />
                        <Grid container>
                            <Grid item sm={6} md={5}>
                                <TextField
                                    fullWidth
                                    error={!this.state.ProjectNameValid}
                                    id="outlined-name"
                                    label="*Project Name"
                                    className={classes.textField}
                                    value={this.state.ProjectName}
                                    onChange={this.handleChange('ProjectName')}
                                />
                                <IntegrationReactSelect
                                    disabledDefaultOptions={true}
                                    handleSelectData={this.handleSelectData}
                                    options={convertClientOptions(clients.items)}
                                    valid={this.state.ClientIdValid}
                                    value={this.state.ClientId}
                                    placeholder='*Client'
                                />
                                <IntegrationReactSelect
                                    disabledDefaultOptions={true}
                                    handleSelectData={this.handleSelectData}
                                    options={convertSalesOptions(users.items)}
                                    valid={this.state.SalesIdValid}
                                    value={this.state.SalesId}
                                    placeholder='*Sales'
                                />
                                <IntegrationReactSelect
                                    disabledDefaultOptions={true}
                                    handleSelectData={this.handleSelectData}
                                    options={convertDepartmentOptions(departments.items)}
                                    valid={this.state.DepartmentIdValid}
                                    value={this.state.DepartmentId}
                                    placeholder='*Project Team'
                                />
                            </Grid>
                            <Grid item sm={6} md={7}>
                                <FormControl component="fieldset" error={this.state.statusValid} className={classes.formControl} hidden={this.state.mode === 'ADD'}>
                                    <FormLabel component="legend">*Status</FormLabel>
                                    <RadioGroup
                                        aria-label="Status"
                                        name="status"
                                        className={classes.group}
                                        value={this.state.Status}
                                        onChange={this.handleChange('Status')}
                                    >
                                        <FormControlLabel value="1" control={<Radio classes={{ root: classes.redRoot, checked: classes.checked }} />} label="Pending" />
                                        <FormControlLabel value="2" control={<Radio classes={{ root: classes.yellowRoot, checked: classes.checked }} />} label="In-progress" />
                                        <FormControlLabel value="3" control={<Radio classes={{ root: classes.greenRoot, checked: classes.checked }} />} label="Completed" />
                                        <FormControlLabel value="4" control={<Radio classes={{ root: classes.greyRoot, checked: classes.checked }} />} label="Archived" />
                                    </RadioGroup>
                                </FormControl>
                                <Grid container>
                                    <Grid item sm={6} md={6}>
                                        <TextField
                                            disabled
                                            fullWidth
                                            id="standard-disabled-dealId"
                                            label="Pipedrive Deal ID"
                                            value={this.state.DealId}
                                            className={classes.textField}
                                            margin="normal"
                                        />
                                        <TextField
                                            disabled
                                            fullWidth
                                            id="standard-disabled-dealTitle"
                                            label="Pipedrive Deal Title"
                                            value={this.state.DealTitle}
                                            className={classes.textField}
                                            margin="normal"
                                        />
                                    </Grid>
                                    <Grid item sm={6} md={6}>
                                        <TextField
                                            disabled
                                            fullWidth
                                            id="standard-disabled-orgName"
                                            label="Pipedrive Deal Client Name"
                                            value={this.state.DealOrgName}
                                            className={classes.textField}
                                            margin="normal"
                                        />
                                        <TextField
                                            disabled
                                            fullWidth
                                            id="standard-disabled-ownerName"
                                            label="Pipedrive Deal Owner Name"
                                            value={this.state.DealOwnerName}
                                            className={classes.textField}
                                            margin="normal"
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <div style={{ marginTop: '40px' }} />
                        <Button color="secondary" variant="outlined" className={classes.button} onClick={this.handleSave}>
                            Save
                        </Button>
                        <Button variant="outlined" className={classes.button} onClick={this.handleClose}>
                            Cancel
                        </Button>
                    </div>
                </Modal>
            </div>
        );
    }
}

function convertClientOptions(ClientsData) {
    const suggestions = ClientsData ? ClientsData.filter(function (item) {
        return item.ClientStatus === 'A'
    }).map(suggestion => ({
        type: 'ClientId',
        label: suggestion.CompanyName,
        id: suggestion.ClientId,
    })) : null;

    return suggestions
}

function convertSalesOptions(UsersData) {
    const suggestions = UsersData ? UsersData.filter(function (item) {
       return item.UserStatus === 'A'
    }).map(suggestion => ({
        type: 'UserId',
        label: suggestion.DepartmentId + ' - ' + suggestion.UserName,
        id: suggestion.UserId,
    })) : null;

    return suggestions
}

function convertDepartmentOptions(DepartmentsData) {
    const suggestions = DepartmentsData ? DepartmentsData.filter(function (item) {
        return item.DepartmentStatus === 'A'
    }).map(suggestion => ({
        type: 'DepartmentId',
        label: suggestion.DepartmentId + ' - ' + suggestion.DepartmentName,
        id: suggestion.DepartmentId,
    })) : null;

    return suggestions
}

function mapStateToProps(state) {
    const { user } = state.authentication;
    const { users, clients, projects, departments } = state;

    return {
        user,
        users,
        clients,
        projects,
        departments
    };
}

FormComponent.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default compose(connect(mapStateToProps), withStyles(styles, { withTheme: true }))(FormComponent);



// WEBPACK FOOTER //
// ./src/components/Projects/FormComponent.js